import { createClient } from '@supabase/supabase-js';

// Supabase configuration - using the same URL and anon key as backend
const supabaseUrl = 'https://auozbrazthbwfmsulyqd.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF1b3picmF6dGhid2Ztc3VseXFkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTA1MzEzMTMsImV4cCI6MjA2NjEwNzMxM30.P9EcGAVof1MwJZ2W4N6fcY296JP-WMJRvkOCfqT8X5s';

// Create Supabase client
const supabase = createClient(supabaseUrl, supabaseAnonKey);

export default supabase; 